<template>
    <div class="d-flex flex-column">
        <label :for="name" class="fw-700 mb-2 text-capitalize">{{$trans(`storefront::flexible_packaging.${name}`)}}<template v-if="required">*</template></label>
        <slot>
            <input type="text" :name="name" @change="handleInput" :value="value" :placeholder="$trans(`storefront::flexible_packaging.${name}`)"
                   class="form-control-secondary" :class="{'is-invalid': store.hasError(name)}">
        </slot>
        <div v-if="store.hasError(name)" class="text-danger" style="margin-top: 2px">
            {{store.getError(name)}}
        </div>
    </div>
</template>

<script>
import {useFlexiblePackagingStore} from "../../../js/store";

export default {
    props: ['required', 'name', 'value'],
    setup() {
        const store = useFlexiblePackagingStore();
        return {
            store: store,
        }
    },
    methods: {
        handleInput: function ($event) {
            this.$emit('input', $event.target.value);
            this.store.removeError(this.name);
        }
    }
}
</script>
